import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import moment from "moment";

import useAxios from "hooks/useAxios";
import ReactStrapTable from "components/reactStrapTable";

const ReferralFile = ({ patientId, tenantID }) => {
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "patientFirstName",
    order: "desc",
    filters: [],
  };
  const API = useAxios();
  // const { patientId, tenantID } = useParams();
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);

  const fetchReferrals = async (filters = {}) => {
    try {
      const { data } = await API.post(
        `/${tenantID}/Referral/Patient/${parseInt(patientId)}`,
        filters
      );
      if (data) {
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchReferrals(initFilter);
  }, []);

  const dateFormate = (row, columnName) => {
    return (
      <>
        {row[columnName]
          ? moment(new Date(row[columnName])).format("MM/DD/YYYY")
          : "-"}
      </>
    );
  };

  const formatter = (row, columnName) => {
    return <>{row[columnName] || "-"}</>;
  };

  const columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 90,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      // cellRenderer: (row) => previewFax(row),
    },
    {
      dataField: "patientFirstName",
      text: "Patient First Name",
      width: 175,
      sort: true,
      cellRenderer: (row) => formatter(row, "patientFirstName"),
      inputType: "text",
      show: true,
    },
    {
      dataField: "patientLastName",
      text: "Patient Last Name",
      width: 175,
      sort: true,
      cellRenderer: (row) => formatter(row, "patientLastName"),
      inputType: "text",
      show: true,
    },
    {
      dataField: "patientDOB",
      text: "Patient Date of Birth",
      width: 150,
      cellRenderer: (row) => dateFormate(row, "patientDOB"),
      inputType: "date",
      show: true,
      sort: true,
    },
    {
      dataField: "medicalRecordNumber",
      text: "Medical Record Number",
      width: 160,
      cellRenderer: (row) => formatter(row, "medicalRecordNumber"),
      inputType: "text",
      show: true,
      sort: true,
    },
    {
      dataField: "referralDate",
      text: "Referral Date",
      width: 140,
      cellRenderer: (row) => dateFormate(row, "referralDate"),
      inputType: "date",
      show: true,
      sort: true,
    },

    {
      dataField: "referralSpecialty",
      text: "Referral Specialty",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralSpecialty"),
      inputType: "date",
      show: true,
      hideColFilter: true,
      sort: false,
    },
    {
      dataField: "referralReason",
      text: "Referral Reason",
      width: 120,
      cellRenderer: (row) => formatter(row, "referralReason"),
      inputType: "text",
      show: true,
      sort: true,
    },
    {
      dataField: "encounterDate",
      text: "Encounter Date",
      width: 120,
      cellRenderer: (row) => dateFormate(row, "encounterDate"),
      inputType: "date",
      show: true,
      sort: true,
    },
    {
      dataField: "referringProviderNPI",
      text: "Referring Provider NPI",
      width: 140,
      cellRenderer: (row) => formatter(row, "referringProviderNPI"),
      inputType: "text",
      show: true,
      sort: true,
    },
    {
      dataField: "referringProviderFirstName",
      text: "Referring Provider First Name",
      width: 140,
      cellRenderer: (row) => formatter(row, "referringProviderFirstName"),
      inputType: "text",
      show: true,
      sort: true,
    },
    {
      dataField: "referringProviderLastName",
      text: "Referring Provider Last Name",
      width: 140,
      cellRenderer: (row) => formatter(row, "referringProviderLastName"),
      inputType: "text",
      show: true,
      sort: true,
    },
    {
      dataField: "referralProviderNPI",
      text: "Referral Provider NPI",
      width: 160,
      cellRenderer: (row) => formatter(row, "referralProviderNPI"),
      inputType: "text",
      show: true,
      sort: true,
    },
    {
      dataField: "referralProviderFirstName",
      text: "Referral Provider First Name",
      width: 160,
      cellRenderer: (row) => formatter(row, "referralProviderFirstName"),
      inputType: "text",
      show: true,
      sort: false,
      hideColFilter: true,
    },
    {
      dataField: "referralProviderLastName",
      text: "Referral Provider Last Name",
      width: 160,
      cellRenderer: (row) => formatter(row, "referralProviderLastName"),
      inputType: "text",
      show: true,
      sort: false,
      hideColFilter: true,
    },
    {
      dataField: "referralProviderPracticeName",
      text: "Practice Name",
      width: 150,
      cellRenderer: (row) => formatter(row, "referralProviderPracticeName"),
      inputType: "text",
      show: true,
      sort: false,
      hideColFilter: true,
    },
    {
      dataField: "referralProviderPracticePhone",
      text: "Practice Phone#",
      width: 160,
      cellRenderer: (row) => formatter(row, "referralProviderPracticePhone"),
      inputType: "text",
      show: true,
      sort: false,
      hideColFilter: true,
    },
    {
      dataField: "referralProviderPracticeFax",
      text: "Practice Fax#",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralProviderPracticeFax"),
      inputType: "text",
      show: true,
      sort: false,
      hideColFilter: true,
    },
  ];

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let filters = { ...filter, filters: [...colChangedFilter] };
      fetchReferrals(filters, true);
      setInitFilter(filters);
    } else {
      setInitFilter(filter);
      fetchReferrals(filter);
    }
  };

  const handleSort = (filter) => {
    setInitFilter(filter);
    fetchReferrals(filter);
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchReferrals(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    let filters = { ...initialFilters, pageSize: initFilter.pageSize, order: initFilter.order, orderBy: initFilter.orderBy };
    fetchReferrals(filters);
    setInitFilter(filters);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    let combinedfilters = { ...initFilter, ...filter }
    if (hasColFilter) {
      combinedfilters.filters = [...colChangedFilter]
    }
    setInitFilter(combinedfilters)
    return fetchReferrals(combinedfilters, true);

  };

  return (
    <div className="table-card scroll-table position-relative border-0">
      <ReactStrapTable
        id="refferrals"
        height={50 * data.length}
        fixedColumn
        columns={columns}
        data={data}
        handleSort={handleSort}
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        hasPagination
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={handlePageChange}
        filters={initFilter}

      />
    </div>
  );
};

export default ReferralFile;
